import React from "react";
import logoRcm from "../../assets/logo_rcm.jpg";
import { Link, useRouteMatch } from "react-router-dom";

const Footer = () => {
	const { path } = useRouteMatch();
	return (
		<footer className="footer">
			<div className="footer__content">
				<div className="footer__left">
					<Link to="/">
						<img src={logoRcm} alt="Logo rc" className="footer_logo" />
					</Link>
				</div>

				<div className="footer__right">
					<nav>
						<ul>
							<li>{path === "/" ? <Link to="/blog">Blog</Link> : <Link to="/">Profile</Link>}</li>
							<li>
								<a href="https://www.linkedin.com/in/raul-camacho-rcm/" target="_blank" rel="noreferrer">
									LinkedIn
								</a>
							</li>
							<li>
								<a href="https://github.com/Raulcmm/" target="_blank" rel="noreferrer">
									GitHub
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
